/**
 * KYC / identity-verification providers a person's KYC record can flow through.
 * Value strings match the provider names used in the wire payload.
 */
export var AfriexKYCProcessor;
(function (AfriexKYCProcessor) {
    AfriexKYCProcessor["Admin"] = "admin";
    AfriexKYCProcessor["Aiprise"] = "aiprise";
    AfriexKYCProcessor["Stripe"] = "stripe";
    AfriexKYCProcessor["Smile"] = "smile";
    AfriexKYCProcessor["Solid"] = "solid";
    AfriexKYCProcessor["SumSub"] = "sumsub";
    AfriexKYCProcessor["TINCheck"] = "tincheck";
    AfriexKYCProcessor["Veriff"] = "veriff";
    AfriexKYCProcessor["Okra"] = "okra";
    AfriexKYCProcessor["StripeIdentity"] = "stripe_identity";
})(AfriexKYCProcessor || (AfriexKYCProcessor = {}));
/**
 * The routing keys `VerificationProcessorSelector.selectByName` accepts.
 *
 * Deliberately NOT `AfriexKYCProcessor`, and the difference is load-bearing:
 * config routes Smile ID as `'smileID'`, which is not an enum member (the enum
 * has `Smile = 'smile'`), and the selector has no `'smile'` case. Validating a
 * stored country KYC processor against the enum would reject the value 34 of
 * the 66 configured countries actually use.
 *
 * `'stripe'` and `'stripe_identity'` both appear because the selector accepts
 * either for Stripe Identity.
 *
 * A drift test asserts every key here resolves through `selectByName`, and that
 * the selector accepts nothing this list omits.
 */
export const KYC_ROUTING_KEYS = [
    'okra',
    'veriff',
    'smileID',
    'sumsub',
    'aiprise',
    'stripe',
    AfriexKYCProcessor.StripeIdentity,
];
//# sourceMappingURL=AfriexKYCProcessor.js.map